var React = require('react');

function PlusRounded (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.56 45.12C35.0195 45.12 45.12 35.0195 45.12 22.56C45.12 10.1005 35.0195 0 22.56 0C10.1005 0 0 10.1005 0 22.56C0 35.0195 10.1005 45.12 22.56 45.12Z","fill":"#F9DFE8","key":0}),React.createElement("path",{"d":"M33.64 23.5801H24.41V32.9401H20.72V23.5801H11.54V20.2501H20.72V10.8701H24.41V20.2801H33.64V23.5801Z","fill":"#091DF3","key":1})]);
}

PlusRounded.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none"};

module.exports = PlusRounded;

PlusRounded.default = PlusRounded;
